import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';

import {
    MetricDataItem,
    percentToTargetRanked,
} from './performance-data/metric.pd.model';

@Component({
    selector: '[cmpsInsightSelectedVisualItem]',
    templateUrl: './selected-visual-item.insight.component.html',
})
export class SelectedVisualItemInsightComponent implements OnChanges, OnInit {
    @Input() pillarName: string;
    @Input() metricName: string;
    @Input() dataMetric: MetricDataItem;
    @Input() showThresholdColours: boolean;
    @Input() showTrendArrows: boolean;

    localState: { width: number };

    constructor() {
        this.localState = { width: 0 };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dataMetric != null) {
            this._setWidth();
        }
    }

    ngOnInit(): void {
        this._setWidth();
    }

    private _setWidth(): void {
        const pttR = !this.dataMetric
            ? null
            : percentToTargetRanked(
                  this.dataMetric.actual,
                  this.dataMetric.target,
                  this.dataMetric.rankOrder,
              );
        this.localState.width = !this.dataMetric ? 0 : Math.abs(pttR * 100);
    }
}
